import React, { Component } from 'react'
import './styles.css'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import Icon from 'components/icons'
import Button from 'components/Button'
import Modal from 'components/Modal'
import VolumeSlider from 'components/VolumeSlider'
import VideoControls from 'components/VideoControls'
import VisitEndingTimer from 'components/VisitEndingTimer'
import LoadingSpinner from 'components/LoadingSpinner'
import NetworkQuality from 'components/NetworkQuality'

class Gallery extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      micOn: true,
      camOn: true,
      phoneOn: true
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.toggleMic = this.toggleMic.bind(this)
    this.toggleCam = this.toggleCam.bind(this)
    this.hangUp = this.hangUp.bind(this)
  }

  openModal() {
    this.setState({showModal: true})
  }

  closeModal() {
    this.setState({showModal: false})
  }

  toggleMic() {
    this.setState({micOn: !this.state.micOn})
  }

  toggleCam() {
    this.setState({camOn: !this.state.camOn})
  }

  hangUp() {
    this.setState({phoneOn: !this.state.phoneOn})
  }

  render() {
    return (
      <div styleName='galleryWrapper'>
        <h3 styleName='galleryHeader'>Gallery</h3>
        <div styleName='gallerySection'>
          <h4 styleName='header'>Icons</h4>
          <div>
            <Icon name='mic-on' width={100} />
            <Icon name='mic-off' width={100} />
            <Icon name='hang-up' width={100} />
            <Icon name='cam-on' width={100} />
            <Icon name='cam-off' width={100} />
            <Icon name='vol-off' width={100} />
            <Icon name='vol-mid' width={100} />
            <Icon name='vol-max' width={100} />
            <Icon name='play' width={100} />
            <Icon name='locked' width={100} />
          </div>
          <div>
            <div styleName='iconWrapper'><Icon name='minutes' width={70} /></div>
            <div styleName='iconWrapper'><Icon name='usd-round' width={70} /></div>
            <div styleName='iconWrapper'><Icon name='star' width={70} /></div>
            <div styleName='iconWrapper'><Icon name='star-filled' width={70} /></div>
            <div styleName='iconWrapper'><Icon name='no-record' width={70} /></div>
          </div>
        </div>


        <div styleName='gallerySection'>
          <h4 styleName='header'>Buttons</h4>
          <div>
            <div styleName='buttonWrapper'><Button type='ok' /></div>
            <div styleName='buttonWrapper'><Button type='go' /></div>
            <div styleName='buttonWrapper'><Button type='decline' /></div>
            <div styleName='buttonWrapper'><Button type='cancel' /></div>
          </div>
        </div>


        <div styleName='gallerySection'>
          <h4 styleName='header'>Modal</h4>
          <div>
            <div styleName='buttonWrapper'>
              <Button type='ok' onClick={this.openModal}>Show Modal</Button>
            </div>
            <Modal
              title='Test Modal'
              show={this.state.showModal}
              footer={(
                <Container>
                  <Row>
                    <Col xs={6}><Button type='cancel' onClick={this.closeModal}>I Decline</Button></Col>
                    <Col xs={6}><Button type='go' onClick={this.closeModal}>I Agree</Button></Col>
                  </Row>
                </Container>
              )}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur non consectetur justo. Mauris mattis ante et felis aliquet luctus. Etiam convallis lorem est, ac tincidunt ipsum auctor suscipit. Phasellus nunc diam, porttitor eget lacinia in, congue nec velit. Quisque imperdiet massa id posuere ornare. Phasellus vehicula augue ut cursus scelerisque. Sed vitae erat nec sem ultricies auctor.
            </Modal>
          </div>
        </div>


        <div styleName='gallerySection'>
          <h4 styleName='header'>Volume Slider</h4>
          <div styleName='sliderWrapper'>
            <VolumeSlider />
          </div>
        </div>

        <div styleName='gallerySection'>
          <h4 styleName='header'>Video Controls</h4>
          <div styleName='sliderWrapper'>
            <VideoControls
              micOn={this.state.micOn}
              camOn={this.state.camOn}
              phoneOn={this.state.phoneOn}
              toggleMic={this.toggleMic}
              toggleCam={this.toggleCam}
              hangUp={this.hangUp}
            />
          </div>
          <div styleName='sliderWrapper'>
            <VideoControls
              micOn={this.state.micOn}
              camOn={this.state.camOn}
              phoneOn={this.state.phoneOn}
              toggleMic={this.toggleMic}
              toggleCam={this.toggleCam}
              hangUp={this.hangUp}
              hideHangUpButton
            />
          </div>
        </div>

        <div styleName='gallerySection'>
          <h4 styleName='header'>Visit Timer</h4>
          <div styleName='timerWrapper'>
            <VisitEndingTimer />
          </div>
        </div>

        <div styleName='gallerySection'>
          <h4 styleName='header'>Loaders</h4>
          <LoadingSpinner />
          <LoadingSpinner color='red' size='15px' />
          <LoadingSpinner color='#676964' size='100px' />
        </div>

        <div styleName='gallerySection'>
          <h4 styleName='header'>Network Quality</h4>
          <NetworkQuality />
          <br />
          <NetworkQuality qualityLevel={1} />
          <br />
          <NetworkQuality qualityLevel={3} />
        </div>
      </div>
    )
  }
}

export default Gallery
